import styled from 'styled-components';

import {
    TextButton,
    spaceMixin,
    Spacer,
} from '@zillow/constellation';

export const StyledTextButton = styled(TextButton)`
    text-align: left;
    align-items: flex-start;

    svg {
        margin-right: ${spaceMixin('xs')};
        ${({ rotateIcon }) => rotateIcon && 'transform: rotate(180deg)'}
    }
`;

export const StyledAccordion = styled(Spacer)`
    overflow: hidden;
    padding-bottom: 4px;
`;

export const StyledPanel = styled(Spacer)`
    max-height: ${({ show }) => (show ? '10em' : '0')};
    transition: all .35s ease-in;
    overflow: hidden;
`;
